import { useLang } from '../../../i18n/LangContext';

export default function Contact() {
  const { t } = useLang();

  return (
    <section id="contact" className="relative py-24 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold mb-4 bg-gradient-to-r from-[#d4af37] to-[#f4d03f] bg-clip-text text-transparent">
            {t('contact_title')}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#d4af37] to-[#f4d03f] mx-auto mb-4"></div>
          <p className="text-gray-400 text-lg">{t('contact_subtitle')}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          <div className="space-y-8">
            <div className="bg-gradient-to-br from-[#1a1f35] to-[#0a0e1a] p-8 rounded-2xl border border-[#d4af37]/20">
              <h3 className="text-2xl font-bold text-[#d4af37] mb-6">{t('contact_info')}</h3>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#d4af37]/10 rounded-lg flex-shrink-0">
                    <i className="ri-mail-line text-2xl text-[#d4af37]"></i>
                  </div>
                  <div>
                    <div className="text-sm text-gray-400 mb-1">{t('contact_email_label')}</div>
                    <div className="text-gray-300">alex.zinger@financial.bg</div>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#d4af37]/10 rounded-lg flex-shrink-0">
                    <i className="ri-phone-line text-2xl text-[#d4af37]"></i>
                  </div>
                  <div>
                    <div className="text-sm text-gray-400 mb-1">{t('contact_phone_label')}</div>
                    <div className="text-gray-300">+48 731 735 872</div>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#d4af37]/10 rounded-lg flex-shrink-0">
                    <i className="ri-time-line text-2xl text-[#d4af37]"></i>
                  </div>
                  <div>
                    <div className="text-sm text-gray-400 mb-1">{t('contact_hours_label')}</div>
                    <div className="text-gray-300">{t('contact_hours_val')}</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-[#1a1f35] to-[#0a0e1a] p-8 rounded-2xl border border-[#d4af37]/20">
              <h3 className="text-xl font-bold text-[#d4af37] mb-4">{t('contact_why')}</h3>
              <ul className="space-y-3">
                {['contact_why1','contact_why2','contact_why3','contact_why4'].map((key) => (
                  <li key={key} className="flex items-start gap-3">
                    <i className="ri-check-line text-[#d4af37] mt-1"></i>
                    <span className="text-gray-300">{t(key)}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="flex flex-col justify-center gap-6">
            <div className="bg-gradient-to-br from-[#1a1f35] to-[#0a0e1a] p-10 rounded-2xl border border-[#d4af37]/20 flex flex-col items-center gap-8">
              <p className="text-gray-300 text-lg text-center">{t('contact_messenger')}</p>

              <a
                href="https://t.me/alexzin7771"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full flex items-center justify-center gap-4 px-8 py-5 rounded-xl font-bold text-lg text-white transition-all duration-300 hover:scale-105 hover:shadow-2xl cursor-pointer whitespace-nowrap"
                style={{ background: 'linear-gradient(135deg, #229ED9 0%, #1a8bbf 100%)', boxShadow: '0 4px 24px rgba(34,158,217,0.25)' }}
              >
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-telegram-fill text-3xl"></i>
                </div>
                Telegram: @alexzin7771
              </a>

              <a
                href="viber://chat?number=%2B48731735872"
                className="w-full flex items-center justify-center gap-4 px-8 py-5 rounded-xl font-bold text-lg text-white transition-all duration-300 hover:scale-105 hover:shadow-2xl cursor-pointer whitespace-nowrap"
                style={{ background: 'linear-gradient(135deg, #7360F2 0%, #5b4bd4 100%)', boxShadow: '0 4px 24px rgba(115,96,242,0.25)' }}
              >
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-phone-fill text-3xl"></i>
                </div>
                Viber: +48 731 735 872
              </a>

              <p className="text-gray-500 text-sm text-center">{t('contact_reply')}</p>
            </div>
          </div>
        </div>
      </div>

      <footer className="mt-24 pt-12 border-t border-[#d4af37]/20">
        <div className="max-w-6xl mx-auto text-center">
          <div className="mb-6">
            <img
              src="https://static.readdy.ai/image/5490f3a4ad0e9eb55a0769efce385370/59278221c6b2727f8d1b3dc0934be840.jpeg"
              alt="Alex Zinger"
              className="w-16 h-16 rounded-full object-cover border-2 border-[#d4af37] mx-auto mb-4"
            />
            <div className="text-xl font-semibold text-[#d4af37]">{t('footer_title')}</div>
            <div className="text-gray-400">{t('footer_subtitle')}</div>
          </div>
          <p className="text-gray-500 text-sm">{t('footer_copy')}</p>
        </div>
      </footer>
    </section>
  );
}
